import * as React from "react";
import { IconButton, Tooltip, Zoom } from "@material-ui/core";
import { AirplanemodeInactive } from "@material-ui/icons";
import { Confirm, useNotify, useRefresh } from "react-admin";
import { useAppDataProvider } from "../../../../../../src/dataprovider";

export const Actions = props => {
  const refresh = useRefresh();
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const [openDialog, setOpenDialog] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const handleDialogClose = () => setOpenDialog(false);
  const handleDialogOpen = () => setOpenDialog(true);
  const OnClickAccept = () => {
    let model = { ...props.record };
    model.isPassive = true;
    setIsLoading(true);
    dataProvider
      .updatePbhReserve(model)
      .then(result => {
        handleDialogClose();
        notify(`Record updated`, "success", false, true);
        refresh();
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  return (
    <React.Fragment>
      <Confirm
        isOpen={openDialog}
        loading={isLoading}
        title={`Deactivated`}
        content="Are you sure you want to deactivated?"
        onConfirm={OnClickAccept}
        onClose={handleDialogClose}
      />

      {props.record.isPassive !== true && (
        <IconButton style={{ width: 40 }} onClick={handleDialogOpen}>
          <Tooltip TransitionComponent={Zoom} title="click button for passive">
            <AirplanemodeInactive />
          </Tooltip>
        </IconButton>
      )}
    </React.Fragment>
  );
};
